'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = require('react-router');

var _reactRouterRedux = require('react-router-redux');

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _webfontloader = require('webfontloader');

var _webfontloader2 = _interopRequireDefault(_webfontloader);

var _getClientConfig = require('./utils/getClientConfig');

var _getClientConfig2 = _interopRequireDefault(_getClientConfig);

var _configConstants = require('../../config/configConstants');

var _configureStore = require('./store/configureStore');

var _configureStore2 = _interopRequireDefault(_configureStore);

var _configureEditorStore = require('./components/editor/store/configureEditorStore');

var _configureEditorStore2 = _interopRequireDefault(_configureEditorStore);

var _initialiseElementTypes = require('./element/initialiseElementTypes');

var _initialiseElementTypes2 = _interopRequireDefault(_initialiseElementTypes);

var _configureMeasurementsStore = require('./components/measurements/store/configureMeasurementsStore');

var _configureMeasurementsStore2 = _interopRequireDefault(_configureMeasurementsStore);

var _ElementConnectionsManager = require('./components/connections/ElementConnectionsManager');

var _ElementConnectionsManager2 = _interopRequireDefault(_ElementConnectionsManager);

var _Root = require('./app/Root');

var _Root2 = _interopRequireDefault(_Root);

require('./scss/main.scss');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
if (process.env.APPLICATION_MODE === 'electron') require('./scss/electron-inject.scss');

// in development, load the fonts required. In prod, these are built to a seperate file.


// Styles


// Utilities


// Constants
// Libraries
if (process.env.NODE_ENV === 'development') require('./scss/font-face.scss');

_webfontloader2.default.load({
    custom: {
        families: ['Source Sans:n4,i4,n7,i7', 'Tiempos:n7,i4', 'Source Code Pro:n4', 'Gotham:n4,n7']
    }
});

/**
 * Index.js
 *  -   Defines the root of the application and creates the store instance as well as
 *      its initial state.
 *  -   Also ensures that the Redux state is synchronised with the URL and vice versa.
 *  -   Installs Immutable.js development tools if we're in the development environment.
 */

/* eslint-disable no-console */
console.log('%cWelcome to %cMilanote', 'font-size: 18px; font-family: Tiempos', 'color: #f4511c; font-size: 18px; font-family: "Tiempos", Times, serif; font-weight: 600;');
/* eslint-enable no-console */

var config = (0, _getClientConfig2.default)();
// Allow immutable JS objects to be printed nicely in the console
if (config.debugLevel >= _configConstants.DEBUG_LEVEL.INFO) {
    var installDevTools = require('immutable-devtools');
    installDevTools.default(Immutable);
}

(0, _initialiseElementTypes2.default)();

var historyManager = process.env.APPLICATION_MODE === 'electron' ? _reactRouter.hashHistory : _reactRouter.browserHistory;

// Stores
var elementConnectionsManager = new _ElementConnectionsManager2.default();
var editorStore = (0, _configureEditorStore2.default)();
var measurementsStore = (0, _configureMeasurementsStore2.default)();
var initialState = Immutable.Map();
var store = (0, _configureStore2.default)(initialState, historyManager, elementConnectionsManager);

// Configure the browser history to instead be wrapped by the react-router-redux history
var historyOptions = {
    selectLocationState: function selectLocationState(state) {
        return state.get('routing');
    }
};
var history = (0, _reactRouterRedux.syncHistoryWithStore)(historyManager, store, historyOptions);

var mountNode = document.getElementById('app');
_reactDom2.default.render(_react2.default.createElement(_Root2.default, { store: store, history: history,
    measurementsStore: measurementsStore,
    editorStore: editorStore,
    elementConnectionsManager: elementConnectionsManager }), mountNode);


//////////////////
// WEBPACK FOOTER
// ./src/client/index.js
// module id = 2030
// module chunks = 0